import { TextDesktop } from '@alfa-bank/site-text-v2/desktop';
import { createWidget } from '@alfa-bank/site-util-create-widget';

import { DateChips as Component } from './date-chips';
import type { IDeps, TDateTab } from './models';
import styles from './styles/styles.css';

export const DateChipsDesktop = createWidget<IDeps, TDateTab>({
    styles,
    Text: TextDesktop,
})(Component);
